import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * RadioGroup
 */
export default class RadioGroup extends Component {
  static propTypes = {
    prefixCls: PropTypes.string,
    /** 子组件name */
    name: PropTypes.string,
    /** 是否禁用 */
    disabled: PropTypes.bool,
    /** 当前值（适用于受控组件） */
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
    /** 默认值 */
    defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    className: PropTypes.string,
    /** 选中状态改变时的回调 function(e, value) */
    onChange: PropTypes.func,
    /** 尺寸 */
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    /** 定制判断值匹配的方法 */
    checkMatching: PropTypes.func,
  };

  static defaultProps = {
    prefixCls: 'ne-radio-group',
    disabled: false,
  };

  static getDerivedStateFromProps(props, state) {
    const { defaultValue } = props;
    if (!state.isControlled && defaultValue !== state.prevDefaultValue) {
      return {
        value: defaultValue,
        prevDefaultValue: defaultValue,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    const { value, defaultValue } = this.props;
    this.isControlled = value != null;
    this.state = {
      isControlled: this.isControlled,
      value: defaultValue,
      prevDefaultValue: defaultValue,
    };
  }

  componentDidUpdate() {
    const { value } = this.props;
    if (!this.isControlled && value != null) {
      this.isControlled = true;
      this.setState({
        value: null,
      });
    }
  }

  onItemChange = itemValue => e => {
    const { onChange } = this.props;
    if (!this.isControlled) {
      this.setState({ value: itemValue });
    }
    if (onChange) {
      onChange(e, itemValue);
    }
  };

  render() {
    const {
      prefixCls,
      className,
      value: propsValue,
      defaultValue,
      disabled,
      name,
      onChange,
      children,
      error,
      inputProps,
      size,
      matchingCondition,
      status,
      errorIcon,
      loadingIcon,
      successIcon,
      showStatusIcon,
      ...other
    } = this.props;
    const { value: stateValue } = this.state;
    const value = this.isControlled ? propsValue : stateValue;
    const items = React.Children.map(children, (child, index) => {
      if (!React.isValidElement(child)) {
        return null;
      }
      const checked = matchingCondition
        ? matchingCondition(child.props.value, value)
        : child.props.value === value;

      return React.cloneElement(child, {
        key: child.props.value || index,
        checked,
        size,
        name: name || child.props.name,
        disabled: disabled || child.props.disabled,
        onChange: this.onItemChange(child.props.value),
      });
    });
    const classes = classNames(
      prefixCls,
      {
        [`${prefixCls}-disabled`]: disabled,
      },
      className,
    );

    return (
      <div className={classes} {...other}>
        {items}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/radio/RadioGroup.jsx